function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M202.7 283.5H81.1l-.4-160.3c0-15.6 9.5-29.6 24-35.5V0h73.5v87.7c14.5 5.8 24 19.9 24 35.5l.5 160.3zm-93-28.5h64.4l-.4-131.8c0-5.4-4.4-9.7-9.7-9.7h-14.3v-85h-16.4v84.9H119c-5.4 0-9.7 4.3-9.7 9.7l.4 131.9z"
})));